export const BLACKLISTED_SENTRY_ERRORS = [
  'Can not register with opener: no bridge found in opener',
  'Failed to fetch',
  'Load failed',
  'NetworkError when attempting to fetch resource.',
  'cancelled',
  'cancelado',
  '已取消',
  'отменено',
  'annulé',
  'キャンセルしました',
  'annullato',
  'Abgebrochen',
  'geannuleerd',
  'dibatalkan',
  'đã hủy',
  'anulat',
  '취소됨',
  '网络连接已中断。',
  'Đã mất kết nối mạng.',
  'Сетевое соединение потеряно.',
  'privateSpecialRepair is not defined',
  'window.bannerNight is not a function',
  "Can't find variable: WeixinJSBridge",
];
export const IGNORE_SENTRY_ERRORS = [
  'Non-Error exception captured',
  'Non-Error promise rejection captured',
  'Illegal invocation',
  'Loading chunk',
  'Loading CSS chunk',
  'Failed to fetch',
  'Load failed',
  'NetworkError when attempting to fetch resource.',
  'cancelled',
  'zaloJSV2',
  'Weixin',
  '400',
  '401',
  '404',
  // Related to New Relic script
  "Cannot read property 'sameOrigin' of undefined",
  "Cannot read properties of undefined (reading 'sameOrigin')",
  "undefined is not an object (evaluating 't.sameOrigin')",
  'Embed startup failed. This is likely because one or all frame components failed to connect. Please check your internet connection.',
  // Related to Hotjar
  "Failed to read the 'localStorage' property from 'Window': Access is denied for this document.",
  // ADA
  'NotSupportedError: The operation is not supported.',
  // Related to Launch Darkly
  "\"Failed to execute 'send' on 'XMLHttpRequest': Failed to load 'https://events.launchdarkly.com/events/bulk/\"",
  "Failed to read the 'localStorage' property from 'Window': Access is denied for this document.",
  // Related with ResizeObserver
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];
export const TAX_ERROR = 'tax_error';
export const INVALID_PARAM_ERROR = 'invalid_param';
export const DUPLICATED_PAYMENT = 'duplicated_payment';
export const TAXES_SERVICE_ERROR = 'taxes_service_error';
export const INBOUND_PROCESSOR_ERROR = 'inbound_processor_error';
export const GENERIC_ERROR = 'generic_error';
export const PAUSED_ERROR = 'access_paused';
export const COUNTRY_MISMATCH_ERROR = 'country_mismatch';

export const SENTRY_IGNORED_CARD_FORM_INTERNAL_ERRORS = [
  'An error occurred while fetching the data.',
  'no DDC Session Id retrieved',
];
